import { DeliveryRoute } from "app/types/route";

const routeDetailCache = new Map<number, DeliveryRoute>();

export function getCachedRouteDetail(routeId: number): DeliveryRoute | undefined {
  return routeDetailCache.get(routeId);
}

export function setCachedRouteDetail(routeId: number, detail: DeliveryRoute): void {
  routeDetailCache.set(routeId, detail);
}

export function invalidateRouteDetailCache(routeId?: number): void {
  if (routeId == null) {
    routeDetailCache.clear();
    return;
  }
  routeDetailCache.delete(routeId);
}
